"use strict";

var _slicedToArray = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utility_1 = require("../common/utility");

var InplaceContextPlugin =
/*#__PURE__*/
function () {
  function InplaceContextPlugin(transcriber) {
    _classCallCheck(this, InplaceContextPlugin);

    this.m_Transcriber = transcriber;
  }

  _createClass(InplaceContextPlugin, [{
    key: "Transcribe",
    value: function Transcribe() {
      var transcriber = this.m_Transcriber;
      transcriber.m_Module.Traverse({
        TaggedTemplateExpression: function TaggedTemplateExpression(path) {
          var tag = path.get("tag");

          if (!tag.isCallExpression()) {
            return;
          }

          var callee = tag.get("callee");
          var callee_name = callee.node.name;

          if (callee_name !== "context" && callee_name !== "Λ") {
            return;
          }

          var _tag$get = tag.get("arguments"),
              _tag$get2 = _slicedToArray(_tag$get, 1),
              arg = _tag$get2[0];

          var dsl_name = arg.node.value;
          var dsl = transcriber.m_DSLMap.get(dsl_name);

          if (!dsl) {
            return;
          }

          var type = tag.node.typeParameters ? utility_1.ToString(tag.node.typeParameters.params[0]) : "";
          path.replaceWith(dsl.InplaceTranscribe(path.get("quasi"), type));
        }
      });
    }
  }]);

  return InplaceContextPlugin;
}();

exports.InplaceContextPlugin = InplaceContextPlugin;